<template>
	<div>
		<el-card class="box-card" shadow="hover">
			<div slot="header" class="clearfix">
				<span>{{title }}</span>
			</div>
			<div class="inputBox">
				<el-form-item
					v-if="i.ishidden == 'False'"
					:class="['inputItem', i.controltype == 'textarea' || i.controltype == 'znsplit' ? 'col24' : 'col12']"
					:label="i.showname"
					label-width="100px"
					v-for="(i, index) in setlist"
					:key="index"
					size="mini"
				>
				<span v-if="isdetail&& i.ishidden == 'False'">{{i.value}}</span>
				<div v-if="!isdetail">
					<el-input
						v-if="i.controltype == 'text' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					></el-input>
					<el-input
						v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						type="text"
						v-model="i.value"
						:ref="i.colname"
						@blur="val => addrinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					></el-input>
					<el-autocomplete
						:ref="i.colname"
						v-if="i.controltype == 'input_filter'"
						v-model="i.value"
						:fetch-suggestions="
							(queryString, cb) => {
								inputsuggestions(queryString, cb, i);
							}
						"
						:style="{ width: `${i.coltdwidth}px` }"
						value-key="showname"
						:trigger-on-focus="true"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
						@select="val => select_change(val, i)"
					></el-autocomplete>
					<!-- 地址联动 -->
					<el-select
						:ref="i.colname"
						v-model="i.value"
						filterable
						remote
						reserve-keyword
						placeholder="可输入关键词搜索"
						:remote-method="val => addrinput(val, i)"
						:loading="loading"
						v-if="i.controltype == 'addrinput' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					>
						<el-option disabled label="可输入关键词搜索" value=""></el-option>
						<el-option v-for="item in i.colsource" :key="item.showname" :label="item.showname" :value="item.showname"></el-option>
					</el-select>
		
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						class="input-with-search"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					>
						<div slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index)">
							<span style="padding:15px"><i class="el-icon-search"></i></span>
						</div>
					</el-input>
		
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
						:type="i.controltype"
						v-model="i.value"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					></el-input>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						filterable
						remote
						reserve-keyword
						placeholder="可输入关键词搜索"
						:loading="loading"
						v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@change.native="val => text_change(val, i)"
						@keyup.native="val => enterinput(val, i)"
					>
						<el-option disabled label="可输入关键词搜索" value=""></el-option>
						<el-option v-for="item in i.colsource" :key="item.value" :label="item.title" :value="item.value"></el-option>
					</el-select>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						v-if="i.controltype == 'select' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@keyup.native="val => enterinput(val, i)"
					>
						<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
					</el-select>
					<!-- :style="{width:`${i.coltdwidth}px`}" -->
					<el-checkbox
						v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
						:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
						:checked="i.coldefault == 1 ? true : false"
						@change="val => setcheck(val, i)"
					></el-checkbox>
		
					<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
					<div v-if="i.controltype == 'znsplit' && i.ishidden == 'False'" class="textare_with_button">
						<el-input type="textarea" v-model="i.value" @keyup.native="val => enterinput(val, i)"></el-input>
						<el-button size="mini" type="warning" @click="znsplit(i)">智能解析</el-button>
					</div>
				  </div>
				</el-form-item>
			</div>
		</el-card>
		<el-dialog :visible.sync="showaddrwin" title="地址簿" width="600px" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true">
			<addresslist
				type="0"
				:addrsearchkey="addrsearchkey"
				:modelindex="modelindex"
				:childrenindex="childrenindex"
				ref="addresslist"
				@rebackaddr="rebackaddr"
			></addresslist>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import addresslist from '@/components/address/addresslist.vue';
export default {
	components: {
		addresslist
	},
	props: {
		classname: {
			type: String,
			default:''
		},
		title:{
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		}
	},
	data() {
		return{
			setlist:[],
			syscol:'',
			receiver:'',
			showaddrwin:false,
			addrsearchkey:'',
			modelindex:0,
			childrenindex:0,
			addrtype:0,
			loading:false,
			orderinfo:{},
			isznsplit:false,
			isdetail:false
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			if(param.syscol!=undefined)
				this.syscol=param.syscol;
			if(param.orderinfo!=undefined){
				this.orderinfo=param.orderinfo;
				if(this.orderinfo.receiver!=undefined)
					this.receiver=this.orderinfo.receiver;
			}
			if(param.isznsplit!=undefined)
				this.isznsplit=param.isznsplit;
			if(param.isdetail!=undefined)
				this.isdetail=param.isdetail;
			this.setlist=[];
			this.getsetlist();
		},
		getsetlist(){
			var that=this;
			this.$apipost.get.GetPagecolSet({syscol:this.syscol,l_mode:this.l_mode}).then(res => {
				if(res.length>0){
					if(that.setlist.length>0)
						that.setlist=that.setlist.concat(res);
					else
						that.setlist=res;
					that.showznsplit();
					// if(that.isznsplit){
					// 	// that.setlist=[{controltype:'znsplit',ishidden:'False',isnull:'True',colname:'cgaddressall',value:'',colnext:'cgname',showname:'智能填写',colwidth:'180'}];
						
					// }
					if(that.receiver!=''){
						that.setlist.forEach(item => {
							for(var i in that.receiver){
								if(item.colname.indexOf(i)>-1){
									item.value=that.receiver[i];
								}
							}
							if(item.value!=undefined){
								if(item.value.toLowerCase()=='cn'&&item.colname.indexOf('country')>-1)
								{
									that.isznsplit=true;
									that.showznsplit();
								}
							}
						});
					}else{
						that.setlist.forEach(item => {
							if(item.coldefault!='')
								item.value=item.coldefault;
							if(item.value!=undefined){
								if(item.value.toLowerCase()=='cn'&&item.colname.indexOf('country')>-1)
								{
									that.isznsplit=true;
									that.showznsplit();
								}
							}
						});
					}
				}
			});
		},
		//地址联动选择
		addrinput(val, i) {
			this.$tool.addrlink_model(this, val, i);
		},
		//文本框输入时自动提示
		inputsuggestions(querystring, cb, i) {
			if (i.colevent != '') {
				this.$tool.addrlink_call_model(this,i, cb);
			}
		},
		//文本框改变
		text_change(val, i) {
			if (i.colevent != '') {
				this.$tool.addrlink_model(this, val, i);
			} else {
				//debugger;
			}
		},
		select_change(val, i){
			//debugger
			if(i.colname.indexOf('country')>-1){
				if(val.value.toLowerCase()=='cn')
				{
					this.isznsplit=true;
					this.showznsplit();
				}else{
					if(this.isznsplit)
						this.hidznsplit();
				}
			}
			if(i.colevent=='country')
				this.$emit('comparecountry');
		},
		showznsplit(){
			if(this.isznsplit){
				var list=this.setlist.filter(function(e){
					return e.controltype=='znsplit';
				});
				debugger
				if(list.length==0){
					this.setlist.unshift({controltype:'znsplit',ishidden:'False',isnull:'True',colname:'cgaddressall',value:'',colnext:'cgname',showname:'智能填写',colwidth:'180'});
				}
			}
		},
		hidznsplit(){
			this.isznsplit=false;
			this.setlist.splice(0,1);
		},
		//智能拆分
		znsplit(i) {
			var address = i.value;
			var that = this;
			//开始解析
			this.$apipost.get.SplitAddr({ addrinfo: address }).then(res => {
				if (res != '') {
					that.setlist.forEach(item => {
						if (item.colname == 'cgname') item.value = res.name;
						if (item.colname == 'cgphone') item.value = res.phone;
						if (item.colname == 'postcode') item.value = res.postcode;
						if (item.colname == 'cgprovince') item.value = res.provice;
						if (item.colname == 'cgcity') item.value = res.city;
						if (item.colname == 'cgdistrict') item.value = res.district;
						
						if (item.colname == 'cgdetailaddr'){
							if(res.street!=undefined){
								item.value = res.street+res.detailaddr;
							}
							else
								item.value = res.detailaddr;
						}
						if (item.colname == 'cgidcard') item.value = res.idcard;
					});
					that.$emit('comparecountry');
				}
			});
		},
		enterinput(event, i,enterinput) {
			//console.log(val);
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if (i.colnext == 'tablegrid') this.$refs.cargo[0].setgridfoucs();
						else this.$refs[i.colnext][0].focus();
					}
				} else if (event.keyCode == 37) {
					if (i.colperv != '') this.$refs[i.colperv][0].focus();
				}
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		checkinput(event, i) {
			if (i.colname == 'ctphone' || i.colname == 'cgphone') {
				if (i.value != '') {
					if (i.coltype == 'phone_10') {
						if (i.value.length < 10) {
							this.$tool.message(i.showname + '不能少于10位', 0);
							this.$refs[i.colname][0].focus();
						}
					}
					if (i.coltype == 'chinaphone') {
						if(!this.$tool.checktel(i.value)){
							this.$tool.message(i.showname + '格式不正确', 0);
							this.$refs[i.colname][0].focus();
						}
					}
				}
			}
		},
		//带搜索的输入框
		inputgroupsearch(i,childrenindex) {
			this.childrenindex = childrenindex;
			this.addrsearchkey = i.value;
			if (this.$refs.addresslist != undefined) {
				this.$refs.addresslist.init({ type: this.addrtype, addresskey: i.value, modelindex: 0, childrenindex: childrenindex });
			}
			this.showaddrwin = true;
		},
		//选地址回填
		rebackaddr(e) {
			var that = this;
			this.setlist.forEach(item => {
					if (item.colname == 'cgcompany') item.value = e.row.company;
					if (item.colname == 'cgname') item.value = e.row.name;
					if (item.colname == 'cgphone') item.value = e.row.phone;
					if (item.colname == 'postcode') item.value = e.row.postcode;
					if (item.colname == 'cgcountry') item.value = e.row.country;
					if (item.colname == 'cgprovince') item.value = e.row.province;
					if (item.colname == 'cgcity') item.value = e.row.city;
					if (item.colname == 'cgidcard') item.value = e.row.idcard;
					if (item.colname == 'cgdistrict') item.value = e.row.district;
					if (item.colname == 'cgdetailaddr') 
					{
						if(e.row.street!=null&&e.row.street!=undefined)
							item.value = e.row.street + e.row.detailaddr;
						else
							item.value = e.row.detailaddr;
					}
			});
			that.$emit('comparecountry');
			this.showaddrwin = false;
		},
	}
}
</script>

<style>
</style>
